{
  "iconUrl": "assets/icons/sprite.svg?v=5df5648054"
}